<template>
	<div class="p-3 mb-2 mr-2 experience-card">
		<div class="mb-2 small">
			<span v-if="experience.end_year">
				{{ experience.end_year - experience.start_year }}
				{{ $t('experience.years') }} ({{ experience.start_year }} -
				{{ experience.end_year }})
			</span>
			<span v-else>
				{{ new Date().getFullYear() - experience.start_year }}
				{{ $t('experience.years') }} ({{ $t('general.since') }}
				{{ experience.start_year }})
			</span>
		</div>
		<h3 class="mb-3 h2 text-uppercase">{{ experience.name }}</h3>
		<div v-if="experience.company" class="mb-1">
			<span style="min-width: 18px;" class="d-inline-block">
				<Icon :icon="['far', 'building']"></Icon>
			</span>
			{{ experience.company }}
		</div>
		<div v-if="experience.occupational_field" class="mb-1">
			<span style="min-width: 18px;" class="d-inline-block">
				<Icon :icon="['far', 'compass']"></Icon>
			</span>
			{{ experience.occupational_field[$getLocaleDbColumn('name')] }}
		</div>
		<div v-if="experience.industry" class="mb-1">
			<span style="min-width: 18px;" class="d-inline-block">
				<Icon :icon="['far', 'industry']"></Icon>
			</span>
			{{ experience.industry[$getLocaleDbColumn('name')] }}
		</div>
		<div v-if="experience.job_position" class="mb-1">
			<span style="min-width: 18px;" class="d-inline-block">
				<Icon :icon="['far', 'user-cog']"></Icon>
			</span>
			{{ $t('jobPositions.' + experience.job_position.name) }}
		</div>
		<div v-if="experience.company_size" class="mb-1">
			<span style="min-width: 18px;" class="d-inline-block">
				<Icon :icon="['far', 'building']"> </Icon>
			</span>
			{{ $t('company-sizes.' + experience.company_size.name) }}
		</div>
	</div>
</template>

<script>
import Icon from '~/components/ui/common/Icon'

export default {
	components: {
		Icon
	},
	props: {
		experience: {
			type: Object,
			required: true
		}
	}
}
</script>

<style scoped>
div.experience-card {
	background: #fafafa;
	border-radius: 0.5rem;
	border: 1px solid #e3e3e3;
}
</style>
